<template>
  <!-- Text -->
  <p class="how-works-info" @click="show = true">
    <img :src="url('/img/icons/info.svg')" alt="Info" class="icon" /> <a
      >{{ $t("How it works") }}?</a
    >
  </p>
  <!-- Popup -->
  <section class="illustration-popup" :class="{ hidden: !show }">
    <div class="illustration-popup__backdrop">
      <div class="illustration-popup__content">
        <a class="illustration-popup__close" @click="show = false">
          <img
            :src="url('/img/icons/cancel-black.svg')"
            alt="Zatvoriť okno"
            class="illustration-popup__close-image"
          />
        </a>
        <div class="illustration-popup__challenge" :class="{ hidden: sent }">
          <h2 class="illustration-popup__title">
            {{ $t("illustration_popup_title") }}
          </h2>
          <div class="illustration-popup__step">
            <div class="illustration-popup__number">1</div>
            <div class="illustration-popup__description">
              {{ $t("illustration_popup_description_1") }}
            </div>
          </div>
          <div class="illustration-popup__step">
            <div class="illustration-popup__number">2</div>
            <div class="illustration-popup__description">
              {{ $t("illustration_popup_description_2") }}
            </div>
          </div>
          <div class="illustration-popup__step">
            <div class="illustration-popup__number">3</div>
            <div class="illustration-popup__description">
              {{ $t("illustration_popup_description_3") }}
            </div>
          </div>
          <a @click="show = false" class="illustration-popup__primary-btn">
            {{ $t("Alright") }}
          </a>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { url } from "../../../../../helpers";

export default {
  data() {
    return {
      show: false,
    };
  },
  setup() {
    return {
      url,
    };
  },
};
</script>
